import React, { useEffect, useMemo } from 'react';
import { useFetchData } from 'hooks/useFetchData';
import { IGetRestaurantBankSettings, IRestaurantBankSettings } from 'types';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';
import { ISelectOption } from 'components/Select/types';
import { getRestaurantBankSettings } from 'backend/restaurants';

interface IRestaurantBankSettingsSelect {
	value: string | null;
	settingsId: string;
	IDSelectedRestaurant: string | null;
	onChange: (value: string | null) => void;
	setFetchedRestaurantBankSettings: (value: IRestaurantBankSettings[]) => void;
}

const RestaurantBankSettingsSelect: React.FC<IRestaurantBankSettingsSelect> = ({
	onChange,
	setFetchedRestaurantBankSettings,
	value,
	settingsId,
	IDSelectedRestaurant,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetRestaurantBankSettings, string>(
		IDSelectedRestaurant ? getRestaurantBankSettings : null,
		IDSelectedRestaurant || '',
	);

	useEffect(() => {
		refetch();
	}, [IDSelectedRestaurant]);

	useEffect(() => {
		if (response) {
			response && setFetchedRestaurantBankSettings(response.data.restaurantBankSettings);
		}
	}, [response]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.restaurantBankSettings.map((el) => ({
				id: el.id,
				name: el.acquirer?.name || '',
			})) || []
		);
	}, [response]);

	return (
		<OutsideFormSelect
			testId="RestaurantBankSettingsSelect"
			label="restaurantBankSettingsLabel"
			name="type"
			errorMessage="selectBankSettings"
			blockId={settingsId}
			value={value}
			options={mappedOptions}
			onChange={onChange}
			loading={loading}
			disabled={!IDSelectedRestaurant}
			fetchError={responseError}
		/>
	);
};

export default React.memo(RestaurantBankSettingsSelect);
